import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Bar } from 'vue-chartjs';
import { BarChartDatasetInterface } from '@/services/QC-V2/statistic/interfaces';
import { Chart } from 'chart.js';

@Component({})
export default class BarChart extends Mixins(Bar) {
  @Prop() private title!: string;
  @Prop() private footerText!: string;
  @Prop() private dataset!: BarChartDatasetInterface;

  public mounted(): void {
    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
        labels: this.dataset.labels,
        datasets: [{
          data: this.dataset.data,
          borderColor: this.dataset.borderColor,
          backgroundColor: this.dataset.backgroundColor,
          pointBorderColor: this.dataset.blobTexts,
        }],
      },
      {
        responsive: true,
        legend: {
          display: false,
        },
        title: {
          text: this.title,
          display: true,
        },
        elements: {
          point: {
            radius: 5,
            pointStyle: 'circle',
            hitRadius: 100,
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count',
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.footerText || '',
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            afterBody: function (item: Chart.ChartTooltipItem[], data: Chart.ChartData): string | string[] {
              const dataIndex: number = item.values().next().value.index;
              const dataSetIndex: number = item.values().next().value.datasetIndex;

              return data.datasets && data.datasets[dataSetIndex]
                ? (data.datasets[dataSetIndex].pointBorderColor as string[])[dataIndex]
                : '';
            },
          },
        },
      },
    );
  }
}
